class ConfiguracaoImpFederais {
  constructor() {
  }
}
export default ConfiguracaoImpFederais
